// components/Hero.js
import React, { useEffect, useRef, useState } from 'react';
import './CSS/Hero.css';  


const Hero = () => {
  const heroRef = useRef(null);
  const [appear, setAppear] = useState(false);

  useEffect(() => {
    const currentHero = heroRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setAppear(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (currentHero) {
      observer.observe(currentHero);
    }

    return () => {
      if (currentHero) {
        observer.unobserve(currentHero);
      }
    };
  }, []);
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero" ref={heroRef}>
      <div className="hero-overlay"></div>
      <div className="hero-container">
        <div className={`hero-content ${appear ? 'appear' : ''}`}>
          <h1 className="hero-title">
            <br />
            Welcome to <br /> <span className="brand-name">Ali Darbar</span>
          </h1>
          <p className="hero-description">
            Experience the finest Mughlai and North Indian cuisine in an ambiance of royal elegance and tradition.
          </p>
          <br />
          <div className="hero-buttons">
            <button className="btn-primary" onClick={() => scrollToSection('menu')}>
              View Menu
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
